import React from 'react'

export type pageProps = {
    children?: any;
    controller: any;
    match?: any;
}

class PageView extends React.Component {
    props: pageProps;
    constructor(props:pageProps){
        super(props)
        this.props = props
    }

    componentDidMount(){
        this.props.controller.pageMounted();
        if (this.props.controller?.pageMounted) {
            this.props.controller.pageMounted();
        }

        if (this.props.controller) {
            const self = this;
            this.props.controller.forceUpdate = function () {
                self.forceUpdate();
            };
        }
    }

    render(){
        return <></>
    }
}

export { PageView }
